export default __webpack_public_path__ + "static/media/picture-5.34f1fa55.png";